import { PiggyBank, TrendingUp, ShieldPlus, LineChart, Lock, ShieldCheck, Zap, CloudUpload } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";

const benefits = [
  { icon: PiggyBank, title: "Reduce Healthcare Costs", desc: "Early identification of health risks helps reduce long-term medical expenditure." },
  { icon: TrendingUp, title: "Improve Productivity", desc: "A healthier workforce results in fewer sick days and improved operational efficiency." },
  { icon: ShieldPlus, title: "Prevent Lifestyle Diseases", desc: "Early intervention programs help reduce diabetes, hypertension, obesity and cardiovascular disease." },
  { icon: LineChart, title: "Data-Driven Decision Making", desc: "Interactive health analytics support HR and management in planning targeted wellness initiatives." },
  { icon: Lock, title: "Confidential & Secure", desc: "Employee medical records are securely stored using encrypted cloud infrastructure with strict confidentiality." },
];

const chips = [
  { icon: ShieldCheck, text: "Reduce Medical Risk" },
  { icon: Zap, text: "Faster Medical Delivery" },
  { icon: CloudUpload, text: "Secure Cloud Storage" },
];

export default function WhyVerifySection() {
  return (
    <section data-testid="why-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="text-center max-w-3xl mx-auto">
          <h2 className="font-display text-[#12294d] text-4xl md:text-6xl tracking-tight" data-testid="why-heading">
            03 — Why <span className="text-[#2ab5cf]">MedVerify</span>
          </h2>
          <p className="mt-5 text-lg md:text-xl text-slate-600" data-testid="why-overline">
            We help clients navigate risk with confidence
          </p>
        </Reveal>

        <Stagger className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((b, i) => (
            <StaggerItem key={b.title}>
              <div className="h-full rounded-[1.5rem] p-8 bg-white border border-[#1a3a6b]/10 shadow-lg shadow-[#1a3a6b]/5" data-testid={`why-benefit-${i}`}>
                <span className="h-14 w-14 rounded-full bg-[#2ab5cf]/12 flex items-center justify-center">
                  <b.icon size={24} className="text-[#2ab5cf]" />
                </span>
                <p className="font-display text-[#12294d] text-xl md:text-2xl tracking-tight mt-6">{b.title}</p>
                <p className="mt-3 text-slate-600 leading-relaxed text-sm">{b.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        <Stagger className="mt-12 flex flex-wrap gap-4 justify-center">
          {chips.map((c, i) => (
            <StaggerItem key={c.text}>
              <span className="glass-chip inline-flex items-center gap-3 px-5 py-3" data-testid={`why-chip-${i}`}>
                <c.icon size={17} className="text-[#2ab5cf]" />
                <span className="text-sm font-bold text-[#12294d]">{c.text}</span>
              </span>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
